import { ResourceData } from 'utils/api/resources/types';
import { Option } from 'shared/interface/globalInterface';

export const resourceDataToOptionMapper = (data: ResourceData): Option[] =>
  data.map((item) => ({ option: item.label, value: item.value }));
